export default function _initBuildContextConstants ({defaultLocale, defaultRegion, useLongCaches, useLiveSafetyFeatures, contentRoot}) {
  return {
    type: 'INIT_BUILD_CONTEXT_CONSTANTS',
    payload: {defaultLocale, defaultRegion, useLongCaches, useLiveSafetyFeatures, contentRoot},
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_initBuildContextConstants.js